function round(value, decPlaces = 2) {
  const multiplier = 10 ** decPlaces;
  const valueHalfUp = value + (0.005 / multiplier);
  const roundedValue = Math.round(valueHalfUp * multiplier);
  return roundedValue / multiplier;
}

function stringToFloat(value = '') {
  const string = `${value}`.replace(',', '.');
  return parseFloat(string) || 0;
}

function checkStringIsOnlyNumbers(value) {
  return /^[0-9]+$/.test(value);
}

export default {
  round,
  stringToFloat,
  checkStringIsOnlyNumbers,
};
